import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Croatia (1-30)
import croatia1 from '../images/croatia1.jpeg';
import croatia2 from '../images/croatia2.jpeg';
import croatia3 from '../images/croatia3.jpeg';
import croatia4 from '../images/croatia4.jpeg';
import croatia5 from '../images/croatia5.jpeg';
import croatia6 from '../images/croatia6.jpeg';
import croatia7 from '../images/croatia7.jpeg';
import croatia8 from '../images/croatia8.jpeg';
import croatia9 from '../images/croatia9.jpeg';
import croatia10 from '../images/croatia10.jpeg';
import croatia11 from '../images/croatia11.jpeg';
import croatia12 from '../images/croatia12.jpeg';
import croatia13 from '../images/croatia13.jpeg';
import croatia14 from '../images/croatia14.jpeg';
import croatia15 from '../images/croatia15.jpeg';
import croatia16 from '../images/croatia16.jpeg';
import croatia17 from '../images/croatia17.jpeg';
import croatia18 from '../images/croatia18.jpeg';
import croatia19 from '../images/croatia19.jpeg';
import croatia20 from '../images/croatia20.jpeg';
import croatia21 from '../images/croatia21.jpeg';
import croatia22 from '../images/croatia22.jpeg';
import croatia23 from '../images/croatia23.jpeg';
import croatia24 from '../images/croatia24.jpeg';
import croatia25 from '../images/croatia25.jpeg';
import croatia26 from '../images/croatia26.jpeg';
import croatia27 from '../images/croatia27.jpeg';
import croatia28 from '../images/croatia28.jpeg';
import croatia29 from '../images/croatia29.jpeg';
import croatia30 from '../images/croatia30.jpeg';

function Croatia() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    croatia1, croatia2, croatia3, croatia4, croatia5, croatia6, croatia7, croatia8, croatia9, croatia10,
    croatia11, croatia12, croatia13, croatia14, croatia15, croatia16, croatia17, croatia18, croatia19, croatia20,
    croatia21, croatia22, croatia23, croatia24, croatia25, croatia26, croatia27, croatia28, croatia29, croatia30
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇭🇷 Croatia 2020 🇭🇷</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Croatia ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Croatia;